var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuAboutUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.5V15.9444C3 15.1193 3.32778 14.328 3.91122 13.7446C4.49467 13.1611 5.28599 12.8333 6.11111 12.8333H9.22222C10.0473 12.8333 10.8387 13.1611 11.4221 13.7446C12.0056 14.328 12.3333 15.1193 12.3333 15.9444V17.5M13.1111 3.60102C13.7803 3.77237 14.3735 4.16157 14.7971 4.70726C15.2206 5.25296 15.4505 5.92411 15.4505 6.61491C15.4505 7.30571 15.2206 7.97686 14.7971 8.52256C14.3735 9.06825 13.7803 9.45745 13.1111 9.6288M17 17.4999V15.9444C16.9961 15.2577 16.765 14.5917 16.343 14.05C15.9209 13.5084 15.3315 13.1216 14.6667 12.9499M4.55556 6.61111C4.55556 7.43623 4.88333 8.22755 5.46678 8.811C6.05023 9.39445 6.84155 9.72222 7.66667 9.72222C8.49178 9.72222 9.28311 9.39445 9.86655 8.811C10.45 8.22755 10.7778 7.43623 10.7778 6.61111C10.7778 5.78599 10.45 4.99467 9.86655 4.41122C9.28311 3.82778 8.49178 3.5 7.66667 3.5C6.84155 3.5 6.05023 3.82778 5.46678 4.41122C4.88333 4.99467 4.55556 5.78599 4.55556 6.61111Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAboutUsIcon);
export default __webpack_public_path__ + "static/media/menu-about-us-icon.ae28dd5b794ad36e5ead72d252319e1c.svg";
export { ForwardRef as ReactComponent };